import React from 'react';
import { NavbarMenuItem } from '@vtblife/layout-config/types';

import styles from './navbar.module.css';
import { NavbarLink } from './components/navbar-link/navbar-link';
import { NavbarButton } from './components/navbar-button/navbar-button';

interface NavbarProps {
    menuItems: NavbarMenuItem[];
    currentPathname?: string;
}

export const Navbar = ({ menuItems, currentPathname }: NavbarProps) => {
    return (
        <nav className={styles.root}>
            <ul className={styles.list}>
                {menuItems.map((item) =>
                    item.href ? (
                        <li key={`${item.href}-${currentPathname}`} className={styles.item}>
                            <NavbarLink item={item} />
                        </li>
                    ) : (
                        <li key={item.title} className={styles.item}>
                            <NavbarButton item={item} />
                        </li>
                    ),
                )}
            </ul>
        </nav>
    );
};
